import React, { useState } from 'react';
import { cx } from '@emotion/css';
import { CircleTimer } from '../../atoms';
import { Alert } from '../alerts';
import useStyles from './TimerCard.styles';
export function TimerCard(props) {
    const [stopped, setStopped] = useState(false);
    const classes = useStyles();
    return (React.createElement(Alert, { className: cx(props.className, classes.root), id: props.id, variant: stopped ? 'success' : 'warning' },
        React.createElement("div", { className: classes.container },
            React.createElement("div", null,
                React.createElement(CircleTimer, { seconds: props.seconds, onTick: props.onTick, onStopped: () => {
                        setStopped(true);
                        if (props.onStopped) {
                            props.onStopped();
                        }
                    } })),
            React.createElement("div", { className: classes.content }, props.children))));
}
//# sourceMappingURL=TimerCard.js.map